<div class="repair-order container pdf-font-{{ company?.appsettings?.pdfFontSize }}">
  <table class="width-100p">
    <!-- <thead class="report-header">
      <div class="repair-order-header">
        <div class="repair-order-company d-flex">
          <div class="repair-order-logo pr-3 align-self-start">
            <img class="company-logo" [src]="company?.logo" />
          </div>
          <div class="repair-order-details flex-column">
            <span class="font-bold dynamicFont">AutoLeap</span>
            <span>{{ company?.phone | mask: '(000) 000-0000' }}</span>
            <span>{{ company?.email }}</span>
            <span>{{ company.formattedAdress }} </span>
            <span *ngIf="company.regNumber && company.regNumber.includes(':')"
              [innerHTML]="this.helperService.formatRegNumber(company?.regNumber)"> </span>
            <span *ngIf="company.regNumber && !company.regNumber.includes(':')"> Business/GST#: {{ company?.regNumber }}
            </span>
          </div>
        </div>
      </div>
    </thead> -->
    <tbody class="report-body">
      <tr>
        <!-- English Privacy Policy -->
        <div *ngIf="currentLang === 'en'">
          <h4 class="font-700">
            Privacy Policy for Mobile Information Collection
          </h4>
          <h5 class="font-700">Introduction</h5>
          <p>We value your privacy and are committed to protecting the personal information you provide to us. This
            Privacy Policy outlines how we collect, use, and protect the mobile phone number you submit through our
            forms.</p>
          <h5 class="font-700">Information Collection and Use</h5>
          <p>When you provide your mobile phone number to us, we collect it for the following purposes: </p>
          <ol>
            <li><b>Notifications and Service Reminders:</b> We use your phone number to send you appointment
              confirmations,
              reminders for scheduled maintenance, and notifications regarding the status of your vehicle repair or
              service.</li>
            <li><b>Promotional Offers and Updates:</b> With your consent, we may
              also use your phone number to send you exclusive promotional offers, updates on new services, and other
              announcements that we believe may be of interest to you.
            </li>
          </ol>
          <h5 class="font-700">Your Privacy and Control </h5>
          <ul>
            <li><b>Opt-Out Option:</b> You may opt out of receiving promotional messages at any time by replying with
              '9' (Opt-out from Notifications like Appointment Reminders) or '8' (Opt-out from Promotional offers &
              discounts)</li>
            <li><b>Frequency of Messages:</b> We aim to keep our communications relevant and will not send more messages
              than necessary.</li>
          </ul>
          <h5 class="font-700">
            Data Security
          </h5>
          <p>
            We implement various security measures to protect your phone number and prevent unauthorized access,
            disclosure, or alteration. Your information is stored securely and is only accessible to authorized
            personnel.
          </p>
          <h5 class="font-700">
            Third-Party Sharing
          </h5>
          <p>
            We do not share your phone number with third-party organizations for marketing or sales purposes without
            your explicit consent.
          </p>
          <h5 class="font-700">
            Changes to This Privacy Policy
          </h5>
          <p class="mb-0">
            We may update this Privacy Policy periodically. Any changes will be posted on our website, and, where
            appropriate, notified to you via text.
          </p>
        </div>

        <!-- French Privacy Policy -->
        <div *ngIf="currentLang === 'fr'">
          <h4 class="font-700">
            Politique de confidentialité pour la collecte d'informations mobiles
          </h4>
          <h5 class="font-700">Introduction</h5>
          <p>Nous accordons une grande importance à votre vie privée et nous engageons à protéger les informations
            personnelles que vous nous fournissez. Cette politique de confidentialité explique comment nous collectons,
            utilisons et protégeons le numéro de téléphone mobile que vous soumettez via nos formulaires.</p>
          <h5 class="font-700">Collecte et utilisation des informations</h5>
          <p>Lorsque vous nous fournissez votre numéro de téléphone mobile, nous le collectons aux fins suivantes :</p>
          <ol>
            <li><b>Notifications et rappels de service :</b> Nous utilisons votre numéro de téléphone pour vous envoyer
              des confirmations de rendez-vous, des rappels pour l'entretien planifié et des notifications concernant
              l'état de la réparation ou du service de votre véhicule.</li>
            <li><b>Offres promotionnelles et mises à jour :</b> Avec votre consentement, nous pouvons également utiliser
              votre numéro de téléphone pour vous envoyer des offres promotionnelles exclusives, des mises à jour sur de
              nouveaux services et d'autres annonces que nous pensons susceptibles de vous intéresser.</li>
          </ol>
          <h5 class="font-700">Votre vie privée et vos choix</h5>
          <ul>
            <li><b>Option de désinscription :</b> Vous pouvez vous désinscrire des messages promotionnels à tout moment
              en répondant avec '9' (se désinscrire des notifications comme les rappels de rendez-vous) ou '8' (se
              désinscrire des offres promotionnelles et des remises).</li>
            <li><b>Fréquence des messages :</b> Nous nous efforçons de rendre nos communications pertinentes et ne vous
              enverrons pas plus de messages que nécessaire.</li>
          </ul>
          <h5 class="font-700">
            Sécurité des données
          </h5>
          <p>
            Nous mettons en œuvre diverses mesures de sécurité pour protéger votre numéro de téléphone et prévenir tout
            accès, divulgation ou modification non autorisé. Vos informations sont stockées en toute sécurité et ne sont
            accessibles qu'au personnel autorisé.
          </p>
          <h5 class="font-700">
            Partage avec des tiers
          </h5>
          <p>
            Nous ne partageons pas votre numéro de téléphone avec des organisations tierces à des fins de marketing ou
            de vente sans votre consentement explicite.
          </p>
          <h5 class="font-700">
            Modifications de cette politique de confidentialité
          </h5>
          <p class="mb-0">
            Nous pouvons mettre à jour cette politique de confidentialité périodiquement. Toute modification sera
            publiée sur notre site web et, le cas échéant, vous sera notifiée par SMS.
          </p>
        </div>
      </tr>
    </tbody>
  </table>
</div>
<div class="footer-company mt-4 text-center font-10 pb-2">
  <div class="repair-order-logo mx-auto mb-1">
    <img class="company-logo" [src]="company?.logo" />
  </div>
  Powered by &copy; AutoLeap Inc., 2025. All rights reserved.
</div>
